"use client";

import Link from "next/link";
import { usePathname, useParams } from "next/navigation";
import { Users, Shield } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { href: "/users", label: "Ekip", icon: Users },
  { href: "/roles", label: "Roller", icon: Shield },
];

/** Replaces the desktop side panel for the Ekip zone — two links don't warrant a column. */
function TeamTabs({ className }: { className?: string }) {
  const pathname = usePathname();
  const { lang } = useParams<{ lang: string }>();

  return (
    <div
      role="tablist"
      className={cn("flex gap-6 border-b border-border", className)}
    >
      {TABS.map(({ href, label, icon: Icon }) => {
        const full = `/${lang}${href}`;
        const active = pathname.startsWith(full);
        return (
          <Link
            key={href}
            href={full}
            role="tab"
            aria-selected={active}
            className={cn(
              "inline-flex items-center gap-2 border-b-2 px-1 pb-3 text-sm font-medium tracking-tight transition-colors",
              active
                ? "border-brand text-brand-light"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="h-4 w-4" aria-hidden />
            {label}
          </Link>
        );
      })}
    </div>
  );
}

export { TeamTabs };
